import React, { FC } from 'react';

import { PropertySettingsTitle } from 'src/components/property-settings/property-settings-title/PropertySettingsTitle';
import { SETTINGS_SECTION_TYPES } from 'src/types/SettingsSectionTypes';

import { usePropertySettings } from '../context';
import { setDraft, setLoading } from '../state';

export const TitleSectionModule: FC = () => {
	const { state, dispatch, isListMode, propertyId, setSourceMode, save, goToProperty } =
		usePropertySettings();

	const nameError = state.errors.find((e) => e.sectionId === SETTINGS_SECTION_TYPES.NAME);

	return (
		<PropertySettingsTitle
			propertyId={propertyId}
			originalProperty={state.original}
			property={state.draft}
			setProperty={(p) => dispatch(setDraft(p))}
			sourceMode={state.sourceMode}
			nameError={nameError}
			editProperty={(p, shouldCrawl) => {
				dispatch(setDraft(p));
				save({ draft: p, isListMode, shouldCrawl });
			}}
			getPropertyData={(s) => setSourceMode(state.draft, s)}
			goToProperty={goToProperty}
			setPropertySourceMode={(s) => {
				setSourceMode(state.draft, s);
			}}
			setLoading={(l) => dispatch(setLoading(l))}
		/>
	);
};
